module.exports = __webpack_public_path__ + "img/donante-julia-gonzalez.d78abf36.png";